export default{light:"300",normal:"400",medium:"500",bolder:"600",bold:"700"};
